export default {
  bbProd: 'https://buyback.luxclusif.com',
  bbSandbox: 'https://buyback-sandbox.luxclusif.com',

  stProd: 'https://selection.luxclusif.com',
  stSandbox: 'https://selection-sandbox.luxclusif.com',

  cmProd: 'https://channels.luxclusif.com',
  cmStaging: 'https://profiles.channels.staging.luxclusif.com',
  cmSandbox: 'https://profiles.channels.sandbox.luxclusif.com',

  cmOffersProd: 'https://offers.channels.luxclusif.com',
  cmOffersStaging: 'https://offers.channels.staging.luxclusif.com',
  cmOffersSandbox: 'https://offers.channels.sandbox.luxclusif.com',

  cmAllocationProd: 'https://allocation.channels.luxclusif.com',
  cmAllocationStaging: 'https://allocation.channels.staging.luxclusif.com',
  cmAllocationSandbox: 'https://allocation.channels.sandbox.luxclusif.com',

  cmCPMProd: 'https://cpm.channels.luxclusif.com',
  cmCPMStaging: 'https://cpm.channels.staging.luxclusif.com',
  cmCPMSandbox: 'https://cpm.channels.sandbox.luxclusif.com',

  ibProd: 'https://inbound.luxclusif.com',
  ibSandbox: 'https://sandbox-inbound.luxclusif.com',

  ivProd: 'https://inventory.luxclusif.com',
  ivSandbox: 'https://sandbox-inventory.luxclusif.com',

  prProd: 'https://products.luxclusif.com',
  prSandbox: 'https://sandbox-products.luxclusif.com',

  opProd: 'https://operations.luxclusif.com',
  opSandbox: 'https://sandbox-operations.luxclusif.com',

  bbEntry: '/buyback',
  stEntry: '/selection',
  cmEntry: '/profile',
  ibEntry: '/inbound',
  ivEntry: '/inventory',
  opEntry: '/operations',
};
